// extracted by mini-css-extract-plugin
module.exports = {"DraftEditor":"Message_DraftEditor__25mEF"};